import { IIntegration, IIntegrationApp } from 'types';
import { IStore } from '../../types';

export const selectIntegrationApps = (state: IStore): IIntegrationApp[] | null => state?.collections?.integrationApps ?? null;

export const selectSiteIntegrations =
  (siteId: string) =>
  (state: IStore): IIntegration[] | undefined =>
    state?.collections?.siteIntegrations?.[siteId];
